module.exports = __webpack_public_path__ + "img/fi-rr-transform.cdce61fe.svg";